const formatMessageText = (text: string): string => {
    if (!text) return '';

    // Split text by newlines first to preserve existing line breaks
    const lines: string[] = text.split('\n');

    // Process each line for bullet points
    const formattedLines = lines.map((line: string) => {
        // Check for bullet points at the start of the line
        if (line.trim().startsWith('•') || line.trim().startsWith('*')) {
            return '\n' + line.trim();
        }

        // Split line by bullet points in the middle
        const bulletSplit = line.split(/(?=[\s[•*]])/);
        return bulletSplit.map((part: string) => {
            if (part.trim().startsWith('•') || part.trim().startsWith('*')) {
                return '\n' + part.trim();
            }
            return part;
        }).join('');
    });

    // Join lines and clean up any multiple consecutive newlines
    let formattedText = formattedLines
        .join('\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();

    // Convert headings (# ## ### #### ##### ######)
    formattedText = formattedText.replace(/^#{6}\s+(.+)$/gm, '<h6>$1</h6>');
    formattedText = formattedText.replace(/^#{5}\s+(.+)$/gm, '<h5>$1</h5>');
    formattedText = formattedText.replace(/^#{4}\s+(.+)$/gm, '<h4>$1</h4>');
    formattedText = formattedText.replace(/^#{3}\s+(.+)$/gm, '<h3>$1</h3>');
    formattedText = formattedText.replace(/^#{2}\s+(.+)$/gm, '<h2>$1</h2>');
    formattedText = formattedText.replace(/^#{1}\s+(.+)$/gm, '<h1>$1</h1>');

    // Convert **bold** to <strong>bold</strong>
    formattedText = formattedText.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // Convert *italic* to <em>italic</em> (but avoid conflicts with bullet points)
    formattedText = formattedText.replace(/(?<!\s)\*([^*\n]+?)\*(?!\s)/g, '<em>$1</em>');

    // Convert `inline code` to <code>inline code</code>
    formattedText = formattedText.replace(/`([^`]+?)`/g, '<code>$1</code>');

    // Convert numbered lists (1. 2. 3. etc.)
    const numberedListRegex = /^(\d+\.\s+.+)$/gm;
    let numberedMatches = formattedText.match(numberedListRegex);
    if (numberedMatches) {
        let listItems = numberedMatches.map(match => {
            const content = match.replace(/^\d+\.\s+/, '');
            return `<li>${content}</li>`;
        }).join('');

        // Replace the original numbered list with HTML
        formattedText = formattedText.replace(numberedListRegex, '###NUMBERED_LIST###');
        formattedText = formattedText.replace('###NUMBERED_LIST###', `<ol>${listItems}</ol>`);
        // Remove any remaining placeholders
        formattedText = formattedText.replace(/###NUMBERED_LIST###/g, '');
    }

    // Convert bullet lists (- or * at start of line, but not the ones we already processed)
    const bulletListRegex = /^[-*]\s+(.+)$/gm;
    let bulletMatches = formattedText.match(bulletListRegex);
    if (bulletMatches) {
        let listItems = bulletMatches.map(match => {
            const content = match.replace(/^[-*]\s+/, '');
            return `<li>${content}</li>`;
        }).join('');

        // Replace the original bullet list with HTML
        formattedText = formattedText.replace(bulletListRegex, '###BULLET_LIST###');
        formattedText = formattedText.replace('###BULLET_LIST###', `<ul>${listItems}</ul>`);
        // Remove any remaining placeholders
        formattedText = formattedText.replace(/###BULLET_LIST###/g, '');
    }

    // Clean up any remaining multiple newlines
    formattedText = formattedText.replace(/\n{3,}/g, '\n\n');

    return formattedText.trim();
};

export default formatMessageText;